// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 534) return "static/chunks/534-0c3f6eff1be3a0b7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 744 ? "949fd6f9" : chunkId) + "." + {"310":"f8d688b96451a080","634":"135425af7180f31d","744":"7f4d1b90760a22ed"}[chunkId] + ".js";
};